<template>
  <div class="office">
    <el-card class="box-card">
      <el-checkbox v-if="!localOffice.isNew" class="pull-right" v-model="remove" @change="hasChanged">Poista</el-checkbox><br />
      <div :class="{disabled: remove}">
        <label :for="'address' + localOffice.id">Osoite</label>
        <input @change="hasChanged" :id="'address' + localOffice.id" type="text" name="address" v-model="localOffice.address">

        <label :for="'postal_code' + localOffice.id">Postinumero</label>
        <input @change="hasChanged" :id="'postal_code' + localOffice.id" type="text" name="postal_code" v-model="localOffice.postal_code">

        <label :for="'post_office' + localOffice.id">Postitoimipaikka</label>
        <input @change="hasChanged" :id="'post_office' + localOffice.id" type="text" name="post_office" v-model="localOffice.post_office">     

        <label :for="'webpage' + localOffice.id">Kotisivut</label>
        <input @change="hasChanged" :id="'webpage' + localOffice.id" type="text" name="webpage" v-model="localOffice.webpage">

        <label :for="'phone' + localOffice.id">Puhelin</label>
        <input @change="hasChanged" :id="'phone' + localOffice.id" type="text" name="phone" v-model="localOffice.phone">
      </div>
    </el-card>
  </div>  
</template>

<script>
  export default {
    props: ['office'],

    data() {
      return {
        localOffice: Object.assign({}, this.office),
        remove: false,
      }
    },

    methods: {
      hasChanged() {
        let changedValues = { 
          newValues: {},
          oldValues: {},
        };
        Object.keys(this.office).forEach((key) => {
          if (this.localOffice[key] !== this.office[key]) {
            changedValues['oldValues'][key] = this.office[key];
            changedValues['newValues'][key] = this.localOffice[key];
          } else {
            changedValues['oldValues'][key] = this.office[key];
          }
        });
        this.$store.dispatch('setNewData', {
          changedValues: !this.remove ? changedValues : { newValues:{}, oldValues:{}, values: this.office },       
          id: this.office.id,
          isNew: typeof this.office.isNew === 'undefined' ? false : true,
          isRemove: this.remove,
          type: 'offices',
        });
      }
    },   
  }
</script>

<style lang="scss" scoped>
  .box-card {
    margin-bottom: 30px;
  }
  .disabled {
    opacity: 0.6;
  }

  form {
    margin: 15px 0 100px;
    input[type="text"],
    input[type="email"],{
      display: block;
      height: 40px;
      line-height: 1em;
      padding: 0 12px;
      margin-bottom: 14px;
      font-size: 1em;
      color: #5c6b80;
      border-radius: 3px;
      vertical-align: middle;
      box-shadow: none;
      border: 0;
      width: 100%;
      max-width: 700px;
      font-family: "Lato","Helvetica Neue",Helvetica,Arial,sans-serif;
      background-color: #eaedf2;
      -webkit-transition: background-color 0.24s ease-in-out;
      transition: background-color 0.24s ease-in-out;
    }
    .zeckit-btn {
      color: #fff !important;
      padding: 15px 30px;
      border: 0;
      -webkit-box-shadow: 0 4px 8px 0 rgba(50,50,50,0.75);
      -moz-box-shadow: 0 4px 8px 0 rgba(50,50,50,0.75);
      box-shadow: 0 4px 8px 0 rgba(50,50,50,0.75);
      text-decoration: none;
      display: table;
      background-color: #002663;
    }
  }
</style>



// WEBPACK FOOTER //
// Office.vue?4012a452